import React, { useState, useEffect, useRef } from "react";
import ExportExcel from "../../../components/ExportExcel";
import API_BASE_URL from "../../../config";
import ExportPDF from "../../../components/ExportPdf";

function MonthlyReport({ project, month, setLoader }) {
  const [report, setReport] = useState(false);
  const [receipt_upto, setReceiptUpto] = useState([]);
  const [receipt_current, setReceiptCurrent] = useState([]);
  const [disposal_upto, setDisposalUpto] = useState([]);
  const [disposal_current, setDisposalCurrent] = useState([]);
  const [props, setProps] = useState([]);
  const [timber, setTimber] = useState([]);
  const [timberCount, setTimberCount] = useState(0);
  const [propsCount, setPropsCount] = useState(0);
  const [project_initial, setProjectInitial] = useState("");
  const [division, setDivision] = useState("");
  const [range, setRange] = useState("");
  const [receipt_upto_count, setReceiptUptoCount] = useState([]);
  const [receipt_current_count, setReceiptCurrentCount] = useState([]);
  const [disposal_upto_count, setDisposalUptoCount] = useState([]);
  const [disposal_current_count, setDisposalCurrentCount] = useState([]);
  const [display_month, setDisplayMonth] = useState("");

  const tableRef = useRef();
  //   const [header, setHeader] = useState(["BARCODE", "DISCOUNT"]);

  useEffect(() => {
    if (project === "" || project === null) {
      setReport(false);
      return;
    }
    fetch(
      `${API_BASE_URL}/api/monthly-report?project=${project}&month=${month}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.error) {
          alert(data.error);
          setLoader(false);
          setReport(false);
          return;
        }
        setReceiptUpto(data.receipt_upto);
        setReceiptCurrent(data.receipt_current);
        setDisposalUpto(data.disposal_upto);
        setDisposalCurrent(data.disposal_current);
        setProps(data.props);
        setTimber(data.timber);
        setProjectInitial(data.project_initial);
        setTimberCount(data.timber_count);
        setPropsCount(data.props_count);
        setDivision(data.division_name);
        setRange(data.range_name);
        setReceiptUptoCount(data.receipt_upto_count);
        setReceiptCurrentCount(data.receipt_current_count);
        setDisposalUptoCount(data.disposal_upto_count);
        setDisposalCurrentCount(data.disposal_current_count);
        setDisplayMonth(data.month);

        setLoader(false);
        setReport(true);
      })
      .catch((err) => {
        console.error("Error fetching entries:", err);
        setLoader(false);
        setReport(false);
        return;
      });
  }, [project, month]);

  return (
    <div id="table-container">
      {report && (
        <>
          <div id="header">
            <p></p>
          </div>
          <div id="table-actions">
            <div id="export-buttons">
              <ExportExcel
                tableId="monthly-progress-report"
                filename={`monthly-progress-report-${project}-${display_month}.xlsx`}
                style={{ marginTop: "5%" }}
              />
              <ExportPDF
                tableId="monthly-progress-report"
                filename={`monthly-progress-report-${project}-${display_month}.pdf`}
                style={{ marginTop: "5%" }}
              />
            </div>
          </div>
          <table id="monthly-progress-report">
            <thead>
              <tr>
                <th colSpan={2}>{project_initial}</th>
                <th colSpan={4 + (timberCount + 1) * 2 + (propsCount + 1)}>
                  Monthly Progress Report of forest produce receipt and disposal
                  of {project}
                </th>
              </tr>
              <tr>
                <th></th>
                <th colSpan={3}>Division : {division}</th>
                <th colSpan={(timberCount + 1) * 2}>{range}</th>
                <th colSpan={propsCount + 1 + 2}>
                  For the Month - {display_month}
                </th>
              </tr>
              <tr>
                <th rowSpan={3}>Sl. No.</th>
                <th rowSpan={3}>Description</th>
                <th rowSpan={3}>Total No. of Trees</th>
                <th rowSpan={3}>Total No. of Felled Trees</th>
                <th
                  colSpan={(timberCount + 1) * 2}
                  style={{ textAlign: "center" }}
                >
                  Timber
                </th>
                <th colSpan={propsCount + 1} style={{ textAlign: "center" }}>
                  Props
                </th>
                <th rowSpan={3}>F/W</th>
                <th rowSpan={3}>Remarks</th>
              </tr>
              <tr>
                {timber.map((item, index) => (
                  <th colSpan={2} style={{ textAlign: "center" }}>
                    {item.type}
                  </th>
                ))}
                <th colSpan={2} style={{ textAlign: "center" }}>
                  Total
                </th>
                {props.map((item, index) => (
                  <th>{item.type}</th>
                ))}
                <th>Total</th>
              </tr>
              <tr>
                {timber.map((item, index) => (
                  <>
                    <th>PCS</th>
                    <th>VOL(m3)</th>
                  </>
                ))}
                <th>PCS</th>
                <th>VOL(m3)</th>
                {props.map((item, index) => (
                  <th>PCS</th>
                ))}
                <th>PCS</th>
              </tr>
            </thead>
            <tbody id="table-body" ref={tableRef}>
              
              <tr>
                <td>1</td>
                <td>Receipt up to the Pre. Month</td>
                <td>
                  {receipt_upto_count[0] ? receipt_upto_count[0][0] || 0 : 0}
                </td>
                <td>
                  {receipt_upto_count[0] ? receipt_upto_count[0][1] || 0 : 0}
                </td>
                {timber.map((t) => {
                  const item = receipt_upto.find(
                    (d) => d[2] === "Timber" && d[3] === t.type
                  );
                  return (
                    <>
                      <td>{item ? item[4] : 0}</td>
                      <td>{item ? item[5].toFixed(2) : 0}</td>
                    </>
                  );
                })}
                <td>
                  {receipt_upto
                    .filter((d) => d[2] === "Timber")
                    .reduce((s, d) => s + Number(d[4] || 0), 0)}
                </td>
                <td>
                  {receipt_upto
                    .filter((d) => d[2] === "Timber")
                    .reduce((s, d) => s + parseFloat(d[5] || 0), 0.0)
                    .toFixed(2)}
                </td>

                {props.map((p) => {
                  const item = receipt_upto.find(
                    (d) => d[2] === "Prop" && d[3] === p.type
                  );
                  return <td>{item ? item[4] : 0}</td>;
                })}
                <td>
                  {receipt_upto
                    .filter((d) => d[2] === "Prop")
                    .reduce((s, d) => s + Number(d[4] || 0), 0)}
                </td>
                <td>
                  {(receipt_upto_count[0]
                    ? receipt_upto_count[0][2] || 0
                    : 0
                  ).toFixed(2)}
                </td>
                <td></td>
              </tr>
              <tr>
                <td>2</td>
                <td>Receipt during the month</td>
                <td>
                  {receipt_current_count[0]
                    ? receipt_current_count[0][0] || 0
                    : 0}
                </td>
                <td>
                  {receipt_current_count[0]
                    ? receipt_current_count[0][1] || 0
                    : 0}
                </td>
                {timber.map((t) => {
                  const item = receipt_current.find(
                    (d) => d[2] === "Timber" && d[3] === t.type
                  );
                  return (
                    <>
                      <td>{item ? item[4] : 0}</td>
                      <td>{item ? item[5].toFixed(2) : 0}</td>
                    </>
                  );
                })}
                <td>
                  {receipt_current
                    .filter((d) => d[2] === "Timber")
                    .reduce((s, d) => s + Number(d[4] || 0), 0)}
                </td>
                <td>
                  {receipt_current
                    .filter((d) => d[2] === "Timber")
                    .reduce((s, d) => s + parseFloat(d[5] || 0), 0.0)
                    .toFixed(2)}
                </td>

                {props.map((p) => {
                  const item = receipt_current.find(
                    (d) => d[2] === "Prop" && d[3] === p.type
                  );
                  return <td>{item ? item[4] : 0}</td>;
                })}
                <td>
                  {receipt_current
                    .filter((d) => d[2] === "Prop")
                    .reduce((s, d) => s + Number(d[4] || 0), 0)}
                </td>
                <td>
                  {(receipt_current_count[0]
                    ? receipt_current_count[0][2] || 0
                    : 0
                  ).toFixed(2)}
                </td>
                <td>
                  {receipt_current_count[0]
                    ? receipt_current_count[0][3] || ""
                    : ""}
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>Running Total of Receipt</td>
                <td>
                  {Number(
                    receipt_current_count[0] ? receipt_current_count[0][0] : 0
                  ) +
                    Number(
                      receipt_upto_count[0] ? receipt_upto_count[0][0] : 0
                    ) || 0}
                </td>
                <td>
                  {Number(
                    receipt_current_count[0] ? receipt_current_count[0][1] : 0
                  ) +
                    Number(
                      receipt_upto_count[0] ? receipt_upto_count[0][1] : 0
                    ) || 0}
                </td>
                {timber.map((t) => {
                  const item_current = receipt_current.find(
                    (d) => d[2] === "Timber" && d[3] === t.type
                  );
                  const item_upto = receipt_upto.find(
                    (d) => d[2] === "Timber" && d[3] === t.type
                  );
                  return (
                    <>
                      <td>
                        {(item_current ? Number(item_current[4]) : 0) +
                          (item_upto ? Number(item_upto[4]) : 0)}
                      </td>
                      <td>
                        {(
                          (item_current ? Number(item_current[5]) : 0) +
                          (item_upto ? Number(item_upto[5]) : 0)
                        ).toFixed(2)}
                      </td>
                    </>
                  );
                })}
                <td>
                  {receipt_current
                    .filter((d) => d[2] === "Timber")
                    .reduce((s, d) => s + Number(d[4] || 0), 0) +
                    receipt_upto
                      .filter((d) => d[2] === "Timber")
                      .reduce((s, d) => s + Number(d[4] || 0), 0)}
                </td>
                <td>
                  {(
                    receipt_current
                      .filter((d) => d[2] === "Timber")
                      .reduce((s, d) => s + parseFloat(d[5] || 0), 0.0) +
                    receipt_upto
                      .filter((d) => d[2] === "Timber")
                      .reduce((s, d) => s + parseFloat(d[5] || 0), 0.0)
                  ).toFixed(2)}
                </td>

                {props.map((p) => {
                  const item_current = receipt_current.find(
                    (d) => d[2] === "Prop" && d[3] === p.type
                  );
                  const item_upto = receipt_upto.find(
                    (d) => d[2] === "Prop" && d[3] === p.type
                  );
                  return (
                    <td>
                      {(item_current ? Number(item_current[4]) : 0) +
                        (item_upto ? Number(item_upto[4]) : 0)}
                    </td>
                  );
                })}
                <td>
                  {receipt_current
                    .filter((d) => d[2] === "Prop")
                    .reduce((s, d) => s + Number(d[4] || 0), 0) +
                    receipt_upto
                      .filter((d) => d[2] === "Prop")
                      .reduce((s, d) => s + Number(d[4] || 0), 0)}
                </td>
                <td>
                  {(
                    Number(
                      receipt_upto_count[0] ? receipt_upto_count[0][2] : 0
                    ) +
                      Number(
                        receipt_current_count[0]
                          ? receipt_current_count[0][2]
                          : 0
                      ) || 0
                  ).toFixed(2)}
                </td>
                <td></td>
              </tr>
              <tr>
                <td>4</td>
                <td>Disposed up to the Pre. Month</td>
                <td>
                  {disposal_upto_count[0] ? disposal_upto_count[0][0] || 0 : 0}
                </td>
                <td>
                  {disposal_upto_count[0] ? disposal_upto_count[0][1] || 0 : 0}
                </td>
                {timber.map((t) => {
                  const item = disposal_upto.find(
                    (d) => d[2] === "Timber" && d[3] === t.type
                  );
                  return (
                    <>
                      <td>{item ? item[4] : 0}</td>
                      <td>{(item ? item[5] : 0).toFixed(2)}</td>
                    </>
                  );
                })}
                <td>
                  {disposal_upto
                    .filter((d) => d[2] === "Timber")
                    .reduce((s, d) => s + Number(d[4] || 0), 0)}
                </td>
                <td>
                  {disposal_upto
                    .filter((d) => d[2] === "Timber")
                    .reduce((s, d) => s + parseFloat(d[5] || 0), 0.0)
                    .toFixed(2)}
                </td>

                {props.map((p) => {
                  const item = disposal_upto.find(
                    (d) => d[2] === "Prop" && d[3] === p.type
                  );
                  return <td>{item ? item[4] : 0}</td>;
                })}
                <td>
                  {disposal_upto
                    .filter((d) => d[2] === "Prop")
                    .reduce((s, d) => s + Number(d[4] || 0), 0)}
                </td>
                <td>
                  {(disposal_upto_count[0]
                    ? disposal_upto_count[0][2] || 0
                    : 0
                  ).toFixed(2)}
                </td>
                <td></td>
              </tr>
              <tr>
                <td>5</td>
                <td>Disposal during the month</td>
                <td>
                  {disposal_current_count[0]
                    ? disposal_current_count[0][0] || 0
                    : 0}
                </td>
                <td>
                  {disposal_current_count[0]
                    ? disposal_current_count[0][1] || 0
                    : 0}
                </td>
                {timber.map((t) => {
                  const item = disposal_current.find(
                    (d) => d[2] === "Timber" && d[3] === t.type
                  );
                  return (
                    <>
                      <td>{item ? item[4] : 0}</td>
                      <td>{item ? item[5].toFixed(2) : 0}</td>
                    </>
                  );
                })}
                <td>
                  {disposal_current
                    .filter((d) => d[2] === "Timber")
                    .reduce((s, d) => s + Number(d[4] || 0), 0)}
                </td>
                <td>
                  {disposal_current
                    .filter((d) => d[2] === "Timber")
                    .reduce((s, d) => s + parseFloat(d[5] || 0), 0.0)
                    .toFixed(2)}
                </td>

                {props.map((p) => {
                  const item = disposal_current.find(
                    (d) => d[2] === "Prop" && d[3] === p.type
                  );
                  return <td>{item ? item[4] : 0}</td>;
                })}
                <td>
                  {disposal_current
                    .filter((d) => d[2] === "Prop")
                    .reduce((s, d) => s + Number(d[4] || 0), 0)}
                </td>
                <td>
                  {(disposal_current_count[0]
                    ? disposal_current_count[0][2] || 0
                    : 0
                  ).toFixed(2)}
                </td>
                <td>
                  {disposal_current_count[0]
                    ? disposal_current_count[0][3] || ""
                    : ""}
                </td>
              </tr>
              <tr>
                <td>6</td>
                <td>Running Total of disposal</td>
                <td>
                  {Number(
                    disposal_current_count[0]
                      ? disposal_current_count[0][0] || 0
                      : 0
                  ) +
                    Number(
                      disposal_upto_count[0]
                        ? disposal_upto_count[0][0] || 0
                        : 0
                    ) || 0}
                </td>
                <td>
                  {Number(
                    disposal_current_count[0]
                      ? disposal_current_count[0][1] || 0
                      : 0
                  ) +
                    Number(
                      disposal_upto_count[0]
                        ? disposal_upto_count[0][1] || 0
                        : 0
                    ) || 0}
                </td>
                {timber.map((t) => {
                  const item_current = disposal_current.find(
                    (d) => d[2] === "Timber" && d[3] === t.type
                  );
                  const item_upto = disposal_upto.find(
                    (d) => d[2] === "Timber" && d[3] === t.type
                  );
                  return (
                    <>
                      <td>
                        {(item_current ? Number(item_current[4]) : 0) +
                          (item_upto ? Number(item_upto[4]) : 0)}
                      </td>
                      <td>
                        {(
                          (item_current ? Number(item_current[5]) : 0) +
                          (item_upto ? Number(item_upto[5]) : 0)
                        ).toFixed(2)}
                      </td>
                    </>
                  );
                })}
                <td>
                  {disposal_current
                    .filter((d) => d[2] === "Timber")
                    .reduce((s, d) => s + Number(d[4] || 0), 0) +
                    disposal_upto
                      .filter((d) => d[2] === "Timber")
                      .reduce((s, d) => s + Number(d[4] || 0), 0)}
                </td>
                <td>
                  {(
                    disposal_current
                      .filter((d) => d[2] === "Timber")
                      .reduce((s, d) => s + parseFloat(d[5] || 0), 0.0) +
                    disposal_upto
                      .filter((d) => d[2] === "Timber")
                      .reduce((s, d) => s + parseFloat(d[5] || 0), 0.0)
                  ).toFixed(2)}
                </td>

                {props.map((p) => {
                  const item_current = disposal_current.find(
                    (d) => d[2] === "Prop" && d[3] === p.type
                  );
                  const item_upto = disposal_upto.find(
                    (d) => d[2] === "Prop" && d[3] === p.type
                  );
                  return (
                    <td>
                      {(item_current ? Number(item_current[4]) : 0) +
                        (item_upto ? Number(item_upto[4]) : 0)}
                    </td>
                  );
                })}
                <td>
                  {disposal_current
                    .filter((d) => d[2] === "Prop")
                    .reduce((s, d) => s + Number(d[4] || 0), 0) +
                    disposal_upto
                      .filter((d) => d[2] === "Prop")
                      .reduce((s, d) => s + Number(d[4] || 0), 0)}
                </td>
                <td>
                  {(
                    Number(
                      disposal_upto_count[0]
                        ? disposal_upto_count[0][2] || 0
                        : 0
                    ) +
                      Number(
                        disposal_current_count[0]
                          ? disposal_current_count[0][2] || 0
                          : 0
                      ) || 0
                  ).toFixed(2)}
                </td>
                <td></td>
              </tr>
              <tr>
                <td>7</td>
                <td>Balance</td>

                {/* Col 3 */}
                <td>
                  {Number(receipt_current_count[0]?.[0] || 0) +
                    Number(receipt_upto_count[0]?.[0] || 0) -
                    (Number(disposal_current_count[0]?.[0] || 0) +
                      Number(disposal_upto_count[0]?.[0] || 0))}
                </td>

                {/* Col 4 */}
                <td>
                  {Number(receipt_current_count[0]?.[1] || 0) +
                    Number(receipt_upto_count[0]?.[1] || 0) -
                    (Number(disposal_current_count[0]?.[1] || 0) +
                      Number(disposal_upto_count[0]?.[1] || 0))}
                </td>

                {/* Timber cols (loop through timber) */}
                {timber.map((t) => {
                  const item_receipt_current = receipt_current.find(
                    (d) => d[2] === "Timber" && d[3] === t.type
                  );
                  const item_receipt_upto = receipt_upto.find(
                    (d) => d[2] === "Timber" && d[3] === t.type
                  );
                  const item_disposal_current = disposal_current.find(
                    (d) => d[2] === "Timber" && d[3] === t.type
                  );
                  const item_disposal_upto = disposal_upto.find(
                    (d) => d[2] === "Timber" && d[3] === t.type
                  );

                  const qty =
                    (item_receipt_current
                      ? Number(item_receipt_current[4])
                      : 0) +
                    (item_receipt_upto ? Number(item_receipt_upto[4]) : 0) -
                    ((item_disposal_current
                      ? Number(item_disposal_current[4])
                      : 0) +
                      (item_disposal_upto ? Number(item_disposal_upto[4]) : 0));

                  const amt =
                    (item_receipt_current
                      ? Number(item_receipt_current[5])
                      : 0) +
                    (item_receipt_upto ? Number(item_receipt_upto[5]) : 0) -
                    ((item_disposal_current
                      ? Number(item_disposal_current[5])
                      : 0) +
                      (item_disposal_upto ? Number(item_disposal_upto[5]) : 0));

                  return (
                    <>
                      <td>{qty}</td>
                      <td>{amt.toFixed(2)}</td>
                    </>
                  );
                })}

                {/* Timber total qty */}
                <td>
                  {receipt_current
                    .filter((d) => d[2] === "Timber")
                    .reduce((s, d) => s + Number(d[4] || 0), 0) +
                    receipt_upto
                      .filter((d) => d[2] === "Timber")
                      .reduce((s, d) => s + Number(d[4] || 0), 0) -
                    (disposal_current
                      .filter((d) => d[2] === "Timber")
                      .reduce((s, d) => s + Number(d[4] || 0), 0) +
                      disposal_upto
                        .filter((d) => d[2] === "Timber")
                        .reduce((s, d) => s + Number(d[4] || 0), 0))}
                </td>

                {/* Timber total amount */}
                <td>
                  {(
                    receipt_current
                      .filter((d) => d[2] === "Timber")
                      .reduce((s, d) => s + parseFloat(d[5] || 0), 0.0) +
                    receipt_upto
                      .filter((d) => d[2] === "Timber")
                      .reduce((s, d) => s + parseFloat(d[5] || 0), 0.0) -
                    (disposal_current
                      .filter((d) => d[2] === "Timber")
                      .reduce((s, d) => s + parseFloat(d[5] || 0), 0.0) +
                      disposal_upto
                        .filter((d) => d[2] === "Timber")
                        .reduce((s, d) => s + parseFloat(d[5] || 0), 0.0))
                  ).toFixed(2)}
                </td>

                {/* Props cols */}
                {props.map((p) => {
                  const item_receipt_current = receipt_current.find(
                    (d) => d[2] === "Prop" && d[3] === p.type
                  );
                  const item_receipt_upto = receipt_upto.find(
                    (d) => d[2] === "Prop" && d[3] === p.type
                  );
                  const item_disposal_current = disposal_current.find(
                    (d) => d[2] === "Prop" && d[3] === p.type
                  );
                  const item_disposal_upto = disposal_upto.find(
                    (d) => d[2] === "Prop" && d[3] === p.type
                  );

                  const qty =
                    (item_receipt_current
                      ? Number(item_receipt_current[4])
                      : 0) +
                    (item_receipt_upto ? Number(item_receipt_upto[4]) : 0) -
                    ((item_disposal_current
                      ? Number(item_disposal_current[4])
                      : 0) +
                      (item_disposal_upto ? Number(item_disposal_upto[4]) : 0));

                  return <td>{qty}</td>;
                })}

                {/* Props total qty */}
                <td>
                  {receipt_current
                    .filter((d) => d[2] === "Prop")
                    .reduce((s, d) => s + Number(d[4] || 0), 0) +
                    receipt_upto
                      .filter((d) => d[2] === "Prop")
                      .reduce((s, d) => s + Number(d[4] || 0), 0) -
                    (disposal_current
                      .filter((d) => d[2] === "Prop")
                      .reduce((s, d) => s + Number(d[4] || 0), 0) +
                      disposal_upto
                        .filter((d) => d[2] === "Prop")
                        .reduce((s, d) => s + Number(d[4] || 0), 0))}
                </td>

                {/* Amount column */}
                <td>
                  {(
                    Number(receipt_upto_count[0]?.[2] || 0) +
                    Number(receipt_current_count[0]?.[2] || 0) -
                    (Number(disposal_upto_count[0]?.[2] || 0) +
                      Number(disposal_current_count[0]?.[2] || 0))
                  ).toFixed(2)}
                </td>

                <td></td>
              </tr>
            </tbody>
          </table>
        </>
      )}
    </div>
  );
}

export default MonthlyReport;
